import { BasicInfoStep } from "./BasicInfoStep";
import { CalibrationStep } from "./CalibrationStep";
import { ConnectionsStep } from "./ConnectionsStep";
import { StepProps } from "./StepProps";
import React, { FC } from "react";

export const ReviewStep: FC<StepProps> = () => {
  return (
    <div className="flex flex-col gap-2">
      <BasicInfoStep disabled={true} />
      <ConnectionsStep disabled={true} />
      <CalibrationStep disabled={true} />
    </div>
  );
};
